// extracted by mini-css-extract-plugin
export var deliveryRow = "_mv-a";
export var fixedHeight = "_mv-4";
export var freightLogo = "_mv-9";
export var fullWidth = "_mv-3";
export var priceColumn = "_mv-5";
export var radioSelected = "_mv-7";
export var radioUnselected = "_mv-6";
export var selectedOption = "_mv-2";
export var selectedOptionContainer = "_mv-1";
export var selection = "_mv-0";
export var tallSkeletonText = "_mv-8";